import { BookOpen } from 'lucide-react'
import type { ReactNode } from 'react'

export function EmptyState({ title, body, action }: { title: string; body: string; action?: ReactNode }) {
  return <div className="empty-state"><BookOpen aria-hidden="true" /><h3>{title}</h3><p>{body}</p>{action}</div>
}
